import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';
import { FormTagsInput } from '@/shared/components/ui/form/components/form-tags-input/form-tags-input';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { GroupSelect } from '@/shared/features/groups/components/group-select/group-select';
import { TUpdateRoleInputSchema } from '@/shared/features/rbac/components/update-role/update-role.types';
import { TUpdateRoleFormProps } from '@/shared/features/rbac/components/update-role-form/update-role-form.types';
import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';

export const UpdateRoleForm: React.FC<TUpdateRoleFormProps> = ({
  handleClose,
  isSystemRole,
  groupSelectProps,
}) => {
  const { t } = useTranslation();
  const { useTenantSettings } = useRbacConfig();
  const { ssoEnabled } = useTenantSettings();

  return (
    <FormContainer justifyContent="space-between">
      <FormContent overflow="auto">
        {!isSystemRole && (
          <>
            <FormInput<TUpdateRoleInputSchema>
              name="name"
              label={t('rbac:role_name')}
              required
            />
            <FormInput<TUpdateRoleInputSchema>
              name="description"
              label={t('rbac:description')}
            />
          </>
        )}
        {ssoEnabled && (
          <FormTagsInput<TUpdateRoleInputSchema>
            name="ssoGroupMapping"
            label={t('rbac:sso_group_mapping')}
            hint={t('rbac:sso_group_mapping_hint')}
          />
        )}
        <GroupSelect<TUpdateRoleInputSchema>
          name="groupId"
          getItemId={(value) => value}
          label={t('groups:group')}
          {...groupSelectProps}
        />
      </FormContent>
      <Submit
        onClose={handleClose}
        submitButtonLabel={t('common:save_changes')}
        formHasToBeDirty
      />
    </FormContainer>
  );
};
